"use client";
import { Button } from "@cmp-src/primitives/button";
import { CalendarIcon } from "@cmp-src/icons/TacticIcons/CalendarIcon";
import { useCallback } from "react";
import { Modal } from "@gettactic/components/src/overlay/modals/Modal/Modal";
import { delegatedPermissionPartials } from "@gettactic/helpers";

interface DelegatedPermissionRequestProps {
  msAuthUrl: string;
  onClose: () => void;
  isOpen?: boolean;
}

export function DelegatedPermissionRequest({
  msAuthUrl,
  onClose,
  isOpen = true
}: DelegatedPermissionRequestProps) {
  const handleConnectOutlook = useCallback(() => {
    window.open(msAuthUrl);
  }, [msAuthUrl]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={delegatedPermissionPartials.title}
      size="sm"
    >
      <DelegatedPermissionRequestContent
        msAuthUrl={msAuthUrl}
        handleConnectOutlook={handleConnectOutlook}
      />
    </Modal>
  );
}

export const DelegatedPermissionRequestContent = ({
  msAuthUrl,
  handleConnectOutlook
}: {
  msAuthUrl: string | undefined;
  handleConnectOutlook: () => void;
}) => {
  return (
    <div className="flex flex-col items-center py-6 text-center">
      <div className="mb-4 rounded-full bg-neutral-200 p-4 opacity-50">
        <CalendarIcon color="white" className="h-10 w-10 text-white" />
      </div>
      <p className="mb-6 px-4">{delegatedPermissionPartials.description}</p>
      <div className="grow" />
      <Button size="lg" disabled={!msAuthUrl} onClick={handleConnectOutlook}>
        {delegatedPermissionPartials.buttonText}
      </Button>
    </div>
  );
};
